import { MemberGrowthSearchFilter } from 'src/modules/statistics/models/memberGrowthSearchFilter';
import { MemberGrowthResponse } from 'src/modules/statistics/models/memberGrowthResponse';
import { PaymentDistributionSearchFilter } from 'src/modules/statistics/models/paymentDistributionSearchFilter';
import { PaymentDistributionResponse } from 'src/modules/statistics/models/paymentDistributionResponse';
import { MembersCount } from 'src/modules/statistics/models/membersCount';
import { MemberCountSearchFilter } from 'src/modules/statistics/models/memberCountSearchFilter';
import { AgeAndGenderDistributionSearchFilter } from 'src/modules/statistics/models/ageAndGenderDistributionSearchFilter';
import { AgeAndGenderDistribution } from 'src/modules/statistics/models/ageAndGenderDistribution';
import { SmsBillingReportGroup, SmsBillingReportSending } from 'src/modules/statistics/models/smsBillingReportResponse';
import AxiosInstance from './axios/interceptor';

const controller = 'Statistics';

export const getMemberGrowth = (options: MemberGrowthSearchFilter) => {
  const endpoint = `${controller}/MemberGrowth`;
  return AxiosInstance.get<MemberGrowthResponse>(endpoint, { params: options });
};
export const getPaymentDistribution = (options: PaymentDistributionSearchFilter) => {
  const endpoint = `${controller}/PaymentDistribution`;
  return AxiosInstance.get<PaymentDistributionResponse>(endpoint, { params: options });
};

export const getAllMemberCount = (options: MemberCountSearchFilter) => {
  const endpoint = `${controller}/MemberCount`;
  return AxiosInstance.get<MembersCount[]>(endpoint, { params: options });
};

export const getCountMembersByAgeAndSex = (options: AgeAndGenderDistributionSearchFilter) => {
  const endpoint = `${controller}/CountMembersByAgeAndSex`;
  return AxiosInstance.get<AgeAndGenderDistribution>(endpoint, { params: options });
};

export const getSmsBillingReport = (fromDate: string, toDate: string) => {
  return AxiosInstance.get<SmsBillingReportGroup[]>('SmsBillingReport', { params: { fromDate, toDate } });
};

export const getSmsBillingReportSendings = (fromDate: string, toDate: string, associationId: number | null) => {
  return AxiosInstance.get<SmsBillingReportSending[]>('SmsBillingReport/sendings', { params: { fromDate, toDate, associationId } });
};

export const triggerSmsBillingReportExport = (fromDate: string, toDate: string, federationName: string) => {
  return AxiosInstance.get('SmsBillingReport/export', { params: { fromDate, toDate, federationName } });
};
